import { getSpacing } from './themeUtils';

// Common
export const SPACING = 8;

// Breakpoints
export const BREAKPOINTS = {
  XS: 320,
  SM: 600,
  MD: 960,
  LG: 1280,
  XL: 1600
};

// Icons
export const ICON_SIZE_SMALL = getSpacing(1.5);
export const ICON_SIZE_MEDIUM = getSpacing(2.25);
export const ICON_SIZE_LARGE = getSpacing(3);

// AppBar
export const APPBAR_SIZE = getSpacing(6);
